<template>
  <input
    type="text"
    class="form-control"
    :id="inputId"
    v-model="localPhone"
    v-mask="phoneMask"
    maxlength="15"
    :required="required"
    placeholder="(00) 00000-0000"
  >
</template>

<script>
import { mask } from 'vue-the-mask';

export default {
  name: 'InvitePhoneField',
  directives: { mask },
  props: {
    modelValue: {
      type: String,
      default: '',
    },
    inputId: {
      type: String,
      default: 'invite_phone',
    },
    required: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      phoneMask: ['(##) ####-####', '(##) #####-####'],
    };
  },
  computed: {
    localPhone: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    },
  },
};
</script>
